export default "/images/book.svg?3fe4268bb96d7875cf1d3cb08ae020e2";